(function() { window.GUID_03c0ae89_047d_47f4_a170_90103fb40ef9 = { getGuid: function() { return "03c0ae89-047d-47f4-a170-90103fb40ef9"; } }; })();
var actionsToDoOnClose = {
    refreshSourceElements: false,
    updateStats: false,
    setHasFinished: false,
    setHas: ''
};
var warningBeforeEditScoreSheet = null;
var inValidationIfCanEditMode = false;
var tournamentEditMode = false;
var dropDownSubstituteInEditMode = null;
let ShowErrorWarning = true;
CS.on('PopupContentLoaded', function (e, source) {
    if (source != undefined) {
        if (source.Params.FormId == "ScoreSheetLive") {
            BindScoreSheet(source);
        }
    }
});
function BindScoreSheet(source) {
    var encounterRowId = $('#encounterRowId', source.Form).val();
    //CS.win.off('beforeunload.scoresheet');
    //CS.win.on('beforeunload.scoresheet', function (e: any) {
    //    if (actionsToDoOnClose.refreshSourceElements) {
    //        debugger;
    //        var div = document.createElement('div');
    //        div.innerHTML = JSRess.PendingChangesScoreSheet;
    //        var decoded = div.firstChild.nodeValue;
    //        var message = decoded;
    //        e.returnValue = message;
    //        return message;
    //    }
    //});
    inValidationIfCanEditMode = false;
    tournamentEditMode = $('#TournamentEditMode', source.Form).val() == "True";
    source.ScoreSheetActionSelector = null;
    var moveSumOfToThisTopCoord = $('#MoveSumOfToThisTopCoord', source.Form).val();
    if (source.ScoreSheetGameHistory == null) {
        source.ScoreSheetGameHistory = $('#ScoreSheetGameHistory', source.Form);
        source.ScoreSheetGameHistory.remove().appendTo(CS.body);
    }
    var autoSaveTimeout = null;
    var autoSaveSubTimeout = null;
    source.OnButtonClicked = function (button, buttonValue) {
        if (autoSaveSubTimeout != null) {
            clearTimeout(autoSaveSubTimeout);
        }
        if (autoSaveTimeout != null) {
            clearTimeout(autoSaveTimeout);
        }
        var actualButton = button;
        var buttonId = actualButton[0].id;
        if (buttonId == "BtnScoreSheetOptions") {
            if (source.ScoreSheetActionSelector == null) {
                source.ScoreSheetActionSelector = $('#ScoreSheetActionSelector', source.Form);
                BindActionSelectorMenu(source, encounterRowId);
            }
            CompuSport.Layout.PositionTargetRefToSourceAndWindows(actualButton, source.ScoreSheetActionSelector);
            if (source.ScoreSheetActionSelector.is(':visible')) {
                source.ScoreSheetActionSelector.slideUp();
            }
            else {
                source.ScoreSheetActionSelector.slideDown();
            }
        }
        else if (buttonId == "BtnScoreSheetUnfinishMatch") {
            UnfinishMatch(source, false);
        }
        else if (buttonId == "BtnScoreSheetFinishMatch") {
            FinishMatch(source);
        }
        else if (buttonId == "BtnScoreSheetSendToApprobation") {
            SendToApprobation(source);
        }
        else if (buttonId == "BtnScoreSheetAccept") {
            AcceptScoreSheet(source);
        }
        else if (buttonId == "BtnScoreSheetReject") {
            RejectScoreSheet(source);
        }
    };
    source.OverrideCloseButton = function () {
        if (actionsToDoOnClose.refreshSourceElements) {
            if (tournamentEditMode) {
                var winnerCups = $('.VTWinnerOfMatch .CSCheckBoxV2 input[type=hidden]', source.Form);
                if (winnerCups.length == 2) {
                    if (winnerCups[0].value == "True" || winnerCups[1].value == "True") {
                        actionsToDoOnClose.setHas = 'Finished';
                    }
                    else {
                        actionsToDoOnClose.setHas = 'NotFinished';
                    }
                }
            }
            DoActionsOnClose(source);
        }
        else {
            source.Close();
        }
    };
    source.OnClosing = function () {
        CS.off('mouseenter.scoresheet');
        CS.off('mousemove.scoresheet');
        CS.off('popup.closed.scoresheet');
        CS.off('click.scoresheet');
        source.ScoreSheetGameHistory.remove();
        dropDownSubstituteInEditMode = null;
    };
    var canEdit = source.Form.find('#canEdit').val();
    if (canEdit == undefined || canEdit.toLowerCase() == "false") {
        return;
    }
    source.BodyLayout = new CS.LayoutElement(CS.body);
    warningBeforeEditScoreSheet = $('#WarningBeforeEditScoreSheet', source.Form);
    CS.off('click.scoresheet');
    CS.off('click.checkbox');
    CS.on('click.scoresheet', function (e) {
        var $element = $(e.target);
        if ($element[0].id != 'BtnScoreSheetOptions' &&
            $element[0].id != 'BtnActivateGameHistoryOnMouseOver' &&
            $element[0].id != 'BtnActivateGameHistoryUnfilteredOnMouseOver' &&
            $element[0].id != 'SLIEncounterTypes' &&
            $element[0].id != "applyToFlowBlock" &&
            !$element.hasClass('CSCheckBoxDiv')) {
            if (source.ScoreSheetActionSelector != null) {
                source.ScoreSheetActionSelector.slideUp();
            }
        }
        if (!$element.hasClass('LayoutLiveItem')) {
            $element = $element.closest('.LayoutLiveItem');
        }
        if ($element.hasClass('LayoutLiveItem')) {
            OnScoreSheetItemClickedLive($element, source, false);
        }
        else {
            ClearIsHighlighted();
        }
    }).on('focus', 'input', function (e) {
        var $element = $(e.target);
        if (!$element.hasClass('LayoutLiveItem')) {
            $element = $element.closest('.LayoutLiveItem');
        }
        if ($element.hasClass('LayoutLiveItem')) {
            OnScoreSheetItemClickedLive($element, source, true);
        }
    }).on('click.checkbox', '.CSCheckBoxV2', function (e) {
        e.preventDefault();
        var $element = $(e.target).closest('.CSCheckBoxV2', source.Form);
        $element.CSCheckBoxV2(true); // sert à réobtenir la nouvelle checkBoxV2 quand elle est rafraichie
        var actualCheckBox = $(this).data('context');
        var actualVal = actualCheckBox.Val();
        actualCheckBox.Val(!actualVal);
    });
    BindSubstituteControls(source);
    $('.CSCheckBoxV2', source.Form).CSCheckBoxV2(true);
    source.Form.off('change keydown');
    source.Form.on('change keydown', function (e) {
        if (e.keyCode > 36 && e.keyCode < 41) {
            e.preventDefault();
            return;
        }
    });
    source.Form.off('change keyup');
    source.Form.on('change keyup', function (e) {
        let $target = $(e.target);
        /*Ne doit pas detecter un changement sur tab, ou les flèches*/
        if (e.keyCode == 9 || (e.keyCode > 36 && e.keyCode < 41)) {
            return;
        }
        else if (e.keyCode == 13) {
            var focusables = $(":focusable");
            var current = focusables.index($target);
            var next = focusables.eq(current + 1).length ? focusables.eq(current + 1) : focusables.eq(0);
            next.focus();
            return;
        }
        var tab = false;
        if ($target[0].tagName == "INPUT" && e.type != 'keyup') {
            //je calcul les inputs box juste sur le keyup et non sur le change parce que sinon, 
            //je double le post parce que le lost focus clanche un change
            /*J'ai placé ce bout en commentaire parce que le keyup n'est pas raisé si je vais tres vite avec le tab, donc, à laisser en commentaires*/
            //return;
            tab = true;
        }
        if (!ValidateIfCanEdit(source)) {
            return;
        }
        if ($target.closest('#SubstitutesContainer').length > 0) {
            let $target = $(e.target);
            $target.addClass('PendSub');
            if (!tab) {
                source.DisableAllButtons();
            }
            if (autoSaveSubTimeout != null) {
                clearTimeout(autoSaveSubTimeout);
            }
            autoSaveSubTimeout = setTimeout(function () {
                PostPendingSubs(source, encounterRowId);
            }, 1000);
        }
        var discValue = $target.closest('.DiscValue');
        if (discValue.length > 0) {
            $target.addClass('Pend');
            if (!tab) {
                source.DisableAllButtons();
            }
            if (autoSaveTimeout != null) {
                clearTimeout(autoSaveTimeout);
            }
            autoSaveTimeout = setTimeout(function () {
                PostPendingValues(source, encounterRowId, moveSumOfToThisTopCoord);
            }, 1000);
        }
    }).on('contextmenu', function (e) {
        e.preventDefault();
    });
    BindDropDowns(source);
}
function BindActionSelectorMenu(source, encounterRowId) {
    source.ScoreSheetActionSelector.on('click', '.OptionMenu', function (e) {
        e.preventDefault();
        if (e.target.id == "BtnSwitchOpponentOfEncounter") {
            SwitchOpponentOfEncounter(source, encounterRowId);
        }
        else if (e.target.id == "BtnClearScoreSheet") {
            ClearScoreSheet(source, encounterRowId);
        }
        else if (e.target.id == "BtnResetScoreErrors") {
            ResetScoreErrors(source, encounterRowId);
        }
        else if (e.target.id == "BtnLetScoreKeepersReenterScores") {
            LetScoreKeepersReenterScores(source, encounterRowId);
        }
        else if (e.target.id == "BtnForceUpdateAllAverage") {
            ForceUpdateAllAverage(source, encounterRowId);
        }
        else if (e.target.id == "BtnAddSubstitutHome") {
            AddSubstitute(source, 0);
        }
        else if (e.target.id == "BtnAddSubstitutVisitor") {
            AddSubstitute(source, 1);
        }
        else if (e.target.id == "BtnForfeit") {
            let $target = $(e.target);
            ForfeitUnforfeitEncounter(source, encounterRowId, !$target.hasClass('IsActive'), $target);
        }
        else if (e.target.id == "BtnActivateGameHistoryUnfilteredOnMouseOver" || e.target.id == "BtnActivateGameHistoryOnMouseOver") {
            let $target = $(e.target);
            var lastHistoryHighlighted = null;
            if ($target.hasClass('IsActive')) {
                $target.removeClass('IsActive');
                CS.off('mouseenter.scoresheet');
                CS.off('mousemove.scoresheet');
            }
            else {
                $target.addClass('IsActive');
                var unfiltered = true;
                if (e.target.id == "BtnActivateGameHistoryOnMouseOver") {
                    unfiltered = false;
                    $('#BtnActivateGameHistoryUnfilteredOnMouseOver').removeClass('IsActive');
                }
                else {
                    unfiltered = true;
                    $('#BtnActivateGameHistoryOnMouseOver').removeClass('IsActive');
                }
                var historyTimer = null;
                CS.off('mouseenter.scoresheet');
                CS.off('mousemove.scoresheet');
                CS.on('mouseenter.scoresheet', '.DiscValue', function (e) {
                    if (historyTimer != null) {
                        clearTimeout(historyTimer);
                    }
                    var $actualElement = $(e.target);
                    historyTimer = setTimeout(function () {
                        $actualElement = $actualElement.closest('.DiscValue');
                        if ($actualElement.length > 0) {
                            var data = {
                                encounterRowId: encounterRowId,
                                scoreSheetTemplateValueId: $actualElement[0].id.replace("E", ""),
                                unfiltered: unfiltered
                            };
                            CompuSport.Ajax.Get(CSParameters.RUrl + "ScoreSheetLive/GetScoreSheetLiveValueHistory/" + CSParameters.SportEventId, data, function (response) {
                                var layout = new CS.LayoutElement($actualElement);
                                var openDirection = 'down';
                                if (source.BodyLayout && layout.Top > source.BodyLayout.VMiddle) {
                                    openDirection = 'up';
                                }
                                if (openDirection == "down") {
                                    source.ScoreSheetGameHistory.css({
                                        left: layout.Left + 'px',
                                        top: layout.Bottom + 'px',
                                        bottom: 'auto'
                                    });
                                }
                                else if (openDirection == "up") {
                                    source.ScoreSheetGameHistory.css({
                                        left: layout.Left + 'px',
                                        top: 'auto',
                                        bottom: source.BodyLayout.Bottom - layout.Top + 'px'
                                    });
                                }
                                source.ScoreSheetGameHistory.html(response);
                                source.ScoreSheetGameHistory.slideDown();
                                $actualElement.addClass('HistoryHighlighted');
                                lastHistoryHighlighted = $actualElement;
                            });
                        }
                    }, 1000);
                }).on('mousemove.scoresheet', function () {
                    source.ScoreSheetGameHistory.hide();
                    if (lastHistoryHighlighted != null) {
                        lastHistoryHighlighted.removeClass('HistoryHighlighted');
                        lastHistoryHighlighted = null;
                    }
                });
            }
        }
    });
    source.ScoreSheetActionSelector.on('change', '#SLIEncounterTypes', function () {
        SelectAnotherScoreSheet(source, encounterRowId, $(this).val());
    });
}
function BindDropDowns(source, context) {
    var dropDowns = null;
    if (context == null) {
        dropDowns = $('.CSDropDownV2', source.Form);
    }
    else {
        dropDowns = $('.CSDropDownV2', context);
    }
    dropDowns.CSDropDownV2();
    dropDowns.off('beforeopen');
    dropDowns.off('extendclick');
    dropDowns.on('beforeopen', function (e, dropdown) {
        if (dropdown.DropDown.parent().hasClass('VTPlayer')) {
            var allDropDownHiddenValues = $('.CSDropDownV2 input[type=hidden]', source.Form);
            var hiddenCount = allDropDownHiddenValues.length;
            dropdown.ElementsValues.removeClass('InUse');
            $.each(dropdown.ElementsValues, function () {
                var elementId = this.id.replace("EId", "");
                for (var i = 0; i < hiddenCount; i++) {
                    var entityId = $(allDropDownHiddenValues[i]).val();
                    if (elementId == entityId) {
                        $(this).addClass('InUse');
                    }
                }
            });
        }
    }).on('extendclick', function (e, dropdown) {
        var data = {
            sourceOfUpdate: 'ScoreSheetLive',
            encounterRowId: $('#encounterRowId', source.Form).val(),
            SelectedTeamId: null,
            positionOrder: 0
        };
        if (dropdown.ExtendedContainer.hasClass('ExtKeyHomePlayers')) {
            data.SelectedTeamId = $('#homeTeamId', source.Form).val();
            data.positionOrder = 0;
        }
        else {
            data.SelectedTeamId = $('#visitorTeamId', source.Form).val();
            data.positionOrder = 1;
        }
        var popup = new CompuSport.Controls.Popup();
        var url = CSParameters.RUrl + 'Teams/AddGridViewMemberOfTeams/' + CSParameters.SportEventId;
        popup.GetAndShow({
            PopupId: 'AddGridViewMemberOfTeams',
            Url: url,
            Data: data,
            AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
        });
        popup.OnPosted = function (response) {
            dropdown.ReplacementElementsWithNewList(response);
        };
    });
    $(".VTPlayer[tabindex='0']").focusin(function () {
        var dropdown = $(this).find('.CSDropDownV2');
        var control = dropdown.data('context');
        control.OpenElementsList();
        //dropdown.on('change', function () {
        //    var focusables = $(":focusable");
        //    var current = focusables.index(dropdown);
        //    var next = focusables.eq(current + 1).length ? focusables.eq(current + 1) : focusables.eq(0);
        //    setTimeout(() => { next.focus(); }, 200);
        //});
    }).focusout(function () {
        var dropdown = $(this).find('.CSDropDownV2');
        var control = dropdown.data('context');
        //dropdown.off('change');
        control.CloseElementsList();
    });
}
function ValidateIfCanEdit(source) {
    if (tournamentEditMode) {
        return true;
    }
    if (inValidationIfCanEditMode) {
        return false;
    }
    if (warningBeforeEditScoreSheet != null && warningBeforeEditScoreSheet.length > 0) {
        inValidationIfCanEditMode = true;
        var popup = CompuSport.Controls.Popup.ShowConfirmDialogV2("", warningBeforeEditScoreSheet[0].innerHTML);
        popup.OnButtonClicked = function (button, value) {
            if (value == "ok") {
                UnfinishMatch(source, true);
            }
            else {
                var data = GetGeneralDataOfScoreSheet(source);
                CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/GetPopup/" + CSParameters.SportEventId, data, function (response) {
                    UpdateSourceContent(source, response);
                });
            }
        };
        return false;
    }
    return true;
}
function GetValueOfInput(input) {
    var value = '';
    if (input.hasClass('CSDropDownV2')) {
        value = input.find('input[type=hidden]').val();
    }
    else if (input.hasClass('CSCheckBoxV2')) {
        value = input.find('input[type=hidden]').val();
    }
    else {
        value = input.val();
    }
    return value;
}
function PostPendingValues(source, encounterRowId, moveSumOfToThisTopCoord) {
    if (tournamentEditMode) {
        // actionsToDoOnClose.refreshSourceElements = true;
        actionsToDoOnClose.updateStats = true;
    }
    var pendingResult = new Array();
    var pendingValues = source.Form.find('.Pend');
    $.each(pendingValues, function () {
        var $this = $(this);
        var id = $this.parent()[0].id.replace("E", "");
        var value = GetValueOfInput($this);
        if (value != $this.data('lv')) {
            pendingResult.push({ Id: id, Value: value });
        }
    });
    if (pendingResult.length > 0) {
        var data = {
            encounterRowId: encounterRowId,
            pendingResult: JSON.stringify(pendingResult),
            moveSumOfToThisTopCoord: moveSumOfToThisTopCoord,
            scoresheetTimeStamp: $('#scoresheetTimeStamp', source.Form).val()
        };
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ScoreSheetAutoSave/" + CSParameters.SportEventId, data, function (response) {
            /*pour chaques valeurs envoyés, présumer qu'elle se sont savé donc ne sont plus en pending.*/
            $.each(pendingValues, function () {
                var $this = $(this);
                $this.removeClass('Pend'); //enlever le pending APRES le save comme ca si le save ne se fait pas y va le refaire plus tard
                var value = GetValueOfInput($this);
                if (value != $this.data('lv')) {
                    $this.data('lv', value); //mettre le lv apres le save aussi.
                }
            });
            if (response == "RELOAD") {
                ReloadScoreSheet(source, encounterRowId);
                return;
            }
            var calculatedResult = $(response);
            $.each(calculatedResult, function (i, element) {
                if (element.id != "") {
                    var oldElement = source.Form.find('#' + element.id);
                    var inputBox = oldElement.find('input');
                    var inputIsCheckbox = false;
                    if (inputBox.length > 0 && inputBox[0].type == 'hidden') {
                        inputBox = inputBox.parent();
                        if (inputBox.hasClass('CSCheckBoxV2')) {
                            inputIsCheckbox = true;
                        }
                    }
                    var isFocused = inputBox.is(':focus');
                    var $newelement = $(element);
                    if (inputBox.length > 0 && isFocused && $newelement.find('input').val() === inputBox.val()) {
                        if ($newelement.hasClass('IsInvalid')) {
                            oldElement.addClass('IsInvalid');
                        }
                        else {
                            oldElement.removeClass('IsInvalid');
                        }
                    }
                    else {
                        if ($newelement.hasClass('VTPlayer')) {
                            BindDropDowns(source, $newelement);
                        }
                        oldElement.replaceWith($newelement);
                    }
                    if (isFocused && inputBox.length > 0) {
                        if (inputIsCheckbox) {
                            $newelement.find('.CSCheckBoxV2').focus();
                        }
                        else {
                            $newelement.find('input').focus();
                        }
                    }
                }
            });
        });
    }
    else {
        source.EnableAllButtons();
    }
}
function PostPendingSubs(source, encounterRowId) {
    if (!ValidateIfCanEdit(source.Form)) {
        source.EnableAllButtons();
        return;
    }
    var pendingValues = source.Form.find('.PendSub');
    var pendingResult = new Array();
    $.each(pendingValues, function () {
        var $this = $(this);
        $this.removeClass('PendSub');
        var substituteLine = $this.closest('.SubstituteLine');
        var id = substituteLine.data('id');
        var teamNumber = substituteLine.data('teamnumber');
        var playerId = substituteLine.find('#SubPlayer' + id + ' input[type=hidden]').val();
        var money = substituteLine.find('.SubMoney').val();
        var average = null;
        var averageGameTypeId = null;
        if ($this.hasClass('SubAverage')) {
            average = $this.val();
            averageGameTypeId = $this.data('gametypeid');
        }
        pendingResult.push({ Id: id, TeamNumber: teamNumber, PlayerId: playerId, AverageStr: average, averageGameTypeId: averageGameTypeId, MoneyStr: money });
    });
    if (pendingResult.length > 0) {
        var data = {
            encounterRowId: encounterRowId,
            pendingResult: JSON.stringify(pendingResult)
        };
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ScoreSheetAutoSaveSubstitutes/" + CSParameters.SportEventId, data, function (response) {
            var calculatedResult = $(response.result);
            $.each(calculatedResult, function (i, element) {
                var oldElement = source.Form.find('#' + element.id);
                oldElement.replaceWith(element);
            });
            if (response.subValues != null && response.subValues.length > 0) {
                let subDropDowns = source.Form.find('.SubstituteDropDown');
                $.each(response.subValues, function (i, subValue) {
                    //Trouve le(s) dropdowns qui a la valeur qui correspond au subValue.EntityId
                    let corrDropDowns = subDropDowns.filter(function () {
                        let $this = $(this);
                        let hidden = $this.find('input');
                        if (hidden.length > 0) {
                            if (hidden.val() == subValue.EntityId) {
                                return true;
                            }
                        }
                    });
                    $.each(corrDropDowns, function (i, dropDown) {
                        let $dropDown = $(dropDown);
                        if ($dropDown.length > 0) {
                            var subAverageContainer = $dropDown.next('.SubAverages');
                            var subAverageInput = subAverageContainer.find('.SubAverage[data-gametypeid="' + subValue.GameTypeId + '"]');
                            if (subAverageInput.length > 0) {
                                subAverageInput.val(subValue.Average);
                            }
                        }
                    });
                });
            }
        });
    }
    else {
        source.EnableAllButtons();
    }
}
function ReloadScoreSheet(source, encounterRowId) {
    var data = GetGeneralDataOfScoreSheet(source);
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ReloadMatch/" + CSParameters.SportEventId, data, function (response) {
        UpdateSourceContent(source, response);
    });
}
function ResetScoreErrors(source, encounterRowId) {
    var popup = CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        var data = GetGeneralDataOfScoreSheet(source);
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ResetScoreErrors/" + CSParameters.SportEventId, data, function (response) {
            UpdateSourceContent(source, response);
        });
    });
}
function UpdateSourceContent(source, response) {
    source.ScoreSheetActionSelector = null;
    source.UpdateContent(response);
}
function AddSubstitute(source, teamNumber) {
    if (!ValidateIfCanEdit(source)) {
        return;
    }
    var actualContainer = null;
    if (teamNumber == 0) {
        actualContainer = $('#SubstitutedPlayersHome');
    }
    else {
        actualContainer = $('#SubstitutedPlayersVisitor');
    }
    var data = GetGeneralDataOfScoreSheet(source);
    data.teamNumber = teamNumber;
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/AddSubstitute/" + CSParameters.SportEventId, data, function (response) {
        UpdateSourceContent(source, response);
    });
}
function BindSubstituteControls(source) {
    var substitutedPlayers = $('#SubstitutesContainer');
    substitutedPlayers.on('click', 'button', function (e) {
        e.preventDefault();
        var $this = $(this);
        var parent = $this.closest('.SubstituteLine');
        $('.SubstituteLine', substitutedPlayers).removeClass('InEditMode');
        if ($this.hasClass('SubEdit')) {
            dropDownSubstituteInEditMode = parent.find('.CSDropDownV2');
            parent.addClass('InEditMode');
            source.Form.addClass('InSubstituteMode');
            source.Form.find('.LayoutLiveItem input').hide();
        }
        else if ($this.hasClass('SubStopEdit')) {
            parent.removeClass('InEditMode');
            dropDownSubstituteInEditMode = null;
            source.Form.removeClass('InSubstituteMode');
            source.Form.find('.LayoutLiveItem input').show();
        }
        else if ($this.hasClass('SubDelete')) {
            var substituteLine = parent;
            var container = substituteLine.parent();
            var subId = substituteLine.data('id');
            var actualSubIndex = substituteLine.data('subindex');
            DeleteScoreSheetSubstitutes(source, subId, function () {
                substituteLine.remove();
                var otherLines = $('.SubstituteLine', container);
                $.each(otherLines, function (e, element) {
                    var $element = $(element);
                    var subIndex = $element.data('subindex');
                    if (subIndex > actualSubIndex) {
                        $element.removeClass('Line' + subIndex);
                        var newIndex = subIndex - 1;
                        $element.addClass('Line' + newIndex);
                        $element.data('subindex', newIndex);
                    }
                });
            });
        }
    });
}
function OnScoreSheetItemClickedLive(element, source, focusMode) {
    ClearIsHighlighted();
    var t = element.data('t'); //TeamNumber
    var g = element.data('g'); //GameNumber
    var p = element.data('p'); //GameNumber
    if (t === "") {
        t = null;
    }
    if (g === "") {
        g = null;
    }
    if (p === "") {
        p = null;
    }
    if (element.hasClass('VTScore')) {
        if (dropDownSubstituteInEditMode != null && !focusMode) {
            var substituteLine = dropDownSubstituteInEditMode.closest('.SubstituteLine');
            var substituteId = substituteLine.data('id');
            var subIndex = substituteLine.data('subindex');
            var scoreSheetTemplateValueId = element[0].id.replace('E', '');
            var bind = false;
            if (element.find('.Sub.SInd' + subIndex + ".SId" + substituteId).length > 0) {
                SubstituteScore(source, substituteId, scoreSheetTemplateValueId, false);
            }
            else {
                SubstituteScore(source, substituteId, scoreSheetTemplateValueId, true);
            }
        }
        else {
            if (t != null && g != null) {
                var game = $('.VTScore[data-g="' + g + '"][data-t=' + t + ']', source.Form);
                game.addClass('IsHighlightedSelf');
                var textBox = game.find('input[type=text]');
                if (textBox.length > 0) {
                    textBox.select();
                }
                var oppGame = $('.VTScore[data-g="' + g + '"][data-t!=' + t + ']', source.Form);
                oppGame.addClass('IsHighlightedOpp');
            }
        }
    }
    else if (element.hasClass('VTPlayer')) {
        var games = $('.VTScore[data-p="' + p + '"][data-t=' + t + ']', source.Form);
        games.addClass('IsHighlightedSelf');
        $.each(games, function (y, game) {
            var g = $(game).data('g');
            var oppGame = $('.VTScore[data-g="' + g + '"][data-t!=' + t + ']', source.Form);
            oppGame.addClass('IsHighlightedOpp');
        });
    }
}
function SubstituteScore(source, substituteId, scoreSheetTemplateValueId, bind) {
    if (!ValidateIfCanEdit(source)) {
        return;
    }
    var data = {
        encounterRowId: $('#encounterRowId', source.Form).val(),
        substituteId: substituteId,
        scoreSheetTemplateValueId: scoreSheetTemplateValueId,
        bind: bind
    };
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/SubstituteGame/" + CSParameters.SportEventId, data, function (response) {
        var results = $(response);
        $.each(results, function (i, element) {
            var oldElement = source.Form.find('#' + element.id);
            oldElement.replaceWith(element);
        });
    });
}
function DeleteScoreSheetSubstitutes(source, id, callback) {
    if (!ValidateIfCanEdit(source)) {
        return;
    }
    var data = GetGeneralDataOfScoreSheet(source);
    data.id = id;
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/DeleteScoreSheetSubstitute/" + CSParameters.SportEventId, data, function (response) {
        UpdateSourceContent(source, response);
    });
}
function UnfinishMatch(source, noWarning) {
    if (noWarning) {
        _unfinishMatch(source);
    }
    else {
        CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
            _unfinishMatch(source);
        });
    }
}
function FinishMatch(source) {
    actionsToDoOnClose.refreshSourceElements = true;
    var data = GetGeneralDataOfScoreSheet(source);
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/FinishMatch/" + CSParameters.SportEventId, data, function (response) {
        if (response.Error != null) {
            CompuSport.Controls.Popup.ShowConfirmDialogV2("", response.Messages, function () { });
        }
        else {
            CloseScoreSheet(source, response); //doit le faire avec le trigger a scoresheetupdated car updatestats devient a false.
            CS.body.trigger('scoresheetupdated', response);
            //source.Close();
        }
    });
}
function LetScoreKeepersReenterScores(source, encounterRowId) {
    actionsToDoOnClose.refreshSourceElements = true;
    actionsToDoOnClose.updateStats = true;
    actionsToDoOnClose.setHas = null;
    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        var data = GetGeneralDataOfScoreSheet(source);
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/LetScoreKeepersReenterScores/" + CSParameters.SportEventId, data, function (response) {
            UpdateSourceContent(source, response);
        });
    });
}
function ForceUpdateAllAverage(source, encounterRowId) {
    actionsToDoOnClose.refreshSourceElements = true;
    actionsToDoOnClose.updateStats = true;
    actionsToDoOnClose.setHas = null;
    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        var data = GetGeneralDataOfScoreSheet(source);
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ForceUpdateAllAverage/" + CSParameters.SportEventId, data, function (response) {
            UpdateSourceContent(source, response);
        });
    });
}
function ClearScoreSheet(source, encounterRowId) {
    actionsToDoOnClose.refreshSourceElements = true;
    actionsToDoOnClose.updateStats = false; //le controlleur le fait.
    actionsToDoOnClose.setHas = null;
    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        var data = GetGeneralDataOfScoreSheet(source);
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ClearScoreSheet/" + CSParameters.SportEventId, data, function (response) {
            UpdateSourceContent(source, response);
        });
    });
}
function SwitchOpponentOfEncounter(source, encounterRowId) {
    actionsToDoOnClose.refreshSourceElements = true;
    actionsToDoOnClose.updateStats = true;
    actionsToDoOnClose.setHas = null;
    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        var data = GetGeneralDataOfScoreSheet(source);
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/SwitchOpponentOfEncounter/" + CSParameters.SportEventId, data, function (response) {
            if (response.message == undefined || response.message == null) {
                UpdateSourceContent(source, response);
            }
            else {
                CompuSport.Controls.Popup.ShowConfirmDialogV2('', response.message);
            }
        });
    });
}
function SelectAnotherScoreSheet(source, encounterRowId, scoreSheetId) {
    actionsToDoOnClose.refreshSourceElements = true;
    actionsToDoOnClose.updateStats = true;
    actionsToDoOnClose.setHas = null;
    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        var data = GetGeneralDataOfScoreSheet(source);
        data.scoreSheetId = scoreSheetId;
        data.applyToAllNextScoreSheets = $('#applyToAllNextScoreSheets')[0].checked;
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/SelectAnotherScoreSheet/" + CSParameters.SportEventId, data, function (response) {
            UpdateSourceContent(source, response);
        });
    });
}
function _unfinishMatch(source) {
    actionsToDoOnClose.refreshSourceElements = true;
    var data = GetGeneralDataOfScoreSheet(source);
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/UnfinishMatch/" + CSParameters.SportEventId, data, function (response) {
        UpdateSourceContent(source, response);
        CS.body.trigger('scoresheetupdated', response);
    });
}
function ForfeitUnforfeitEncounter(source, encounterRowId, isForfeit, button) {
    if (!ValidateIfCanEdit(source)) {
        return;
    }
    actionsToDoOnClose.refreshSourceElements = true;
    var data = GetGeneralDataOfScoreSheet(source);
    data.isForfeit = isForfeit;
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/ForfeitUnforfeitEncounter/" + CSParameters.SportEventId, data, function (response) {
        UpdateSourceContent(source, response);
    });
}
function SendToApprobation(source) {
    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
        /*verifier le me match peut se terminer.*/
        actionsToDoOnClose.refreshSourceElements = true;
        var data = GetGeneralDataOfScoreSheet(source);
        CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/SendToApprobation/" + CSParameters.SportEventId, data, function (response) {
            if (response.Error != null) {
                CompuSport.Controls.Popup.ShowConfirmDialogV2("", response.Messages, function () { });
                ReloadScoreSheet(source, null);
            }
            else {
                CloseScoreSheet(source, response);
            }
        });
    });
}
function AcceptScoreSheet(source) {
    actionsToDoOnClose.refreshSourceElements = true;
    actionsToDoOnClose.updateStats = true;
    var data = GetGeneralDataOfScoreSheet(source);
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/AcceptScoreSheet/" + CSParameters.SportEventId, data, function (response) {
        if (response.Error != null) {
            CompuSport.Controls.Popup.ShowConfirmDialogV2("", response.Messages, function () { });
        }
        else {
            CloseScoreSheet(source, response);
        }
    });
}
function RejectScoreSheet(source) {
    var message = $('.RejectReasonTitle')[0].innerHTML;
    CompuSport.Controls.Popup.ShowInputDialogV2(message, true, function (inputValue, accepted) {
        if (accepted) {
            actionsToDoOnClose.refreshSourceElements = true;
            var data = GetGeneralDataOfScoreSheet(source);
            data.rejectReason = inputValue;
            CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/RejectScoreSheet/" + CSParameters.SportEventId, data, function (response) {
                if (response.Error != null) {
                    CompuSport.Controls.Popup.ShowConfirmDialogV2("", response.Messages, function () { });
                }
                else {
                    CloseScoreSheet(source, response);
                }
            });
        }
    });
}
function CloseScoreSheet(source, response) {
    source.OverrideCloseButton();
}
function GetGeneralDataOfScoreSheet(source) {
    var data = {
        encounterRowId: source.Form.find('#encounterRowId').val(),
        elementToRefresh: source.Form.find('#elementToRefresh').val(),
        flowBlockId: source.Form.find('#FlowBlockId').val(),
        updateStats: actionsToDoOnClose.updateStats,
        setHas: actionsToDoOnClose.setHas,
        teamNumber: null,
        isFinished: false,
        id: null,
        isForfeit: false,
        rejectReason: null,
        ShowErrorWarning: true
    };
    return data;
}
function DoActionsOnClose(source) {
    var data = GetGeneralDataOfScoreSheet(source);
    data.ShowErrorWarning = ShowErrorWarning;
    CS.navLoadingIndicator.show();
    CompuSport.Ajax.Post(CSParameters.RUrl + "ScoreSheetLive/DoActionsOnClose/" + CSParameters.SportEventId, data, function (response) {
        if (response.Error || response.Info || response.Warning) {
            CS.navLoadingIndicator.hide();
            CompuSport.Controls.Popup.ShowConfirmDialogV2("", response.Messages, function () { });
            ReloadScoreSheet(source, null);
            ShowErrorWarning = false;
            return;
        }
        ShowErrorWarning = true;
        CS.body.trigger('scoresheetupdated', response);
        CS.navLoadingIndicator.hide();
        source.Close();
    });
}

//# sourceMappingURL=ScoreSheetLive.js.map
